import legends from '../../data/legends.json' with { type: 'json' };

export const LEGENDS = Object.freeze([...legends]);
